export class AccountStatementTypeFilter {
    public IncludeInactive?: boolean;
}

export default AccountStatementTypeFilter;